module.exports = __webpack_public_path__ + "img/translationeditor_1.e771a6e4.jpg";